module.exports = __webpack_public_path__ + "assets/31036fb7b9055cc4b8efda06f2129174.png";